import { CurrencySettings } from './codes';

const { eur, gbp, nok, sek, nzd, dkk } = CurrencySettings;

export const MarketSettings = {
  gb: gbp,
  fr: eur,
  fi: eur,
  no: nok,
  nz: nzd,
  se: sek,
  dk: dkk,
};
